<div class="report row mx-md-0 px-md-0">
  <div class="field col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-3 d-flex justify-content-start">
        <span class="">Client:</span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold mx-md-0 px-md-0">
        <span class="itemCreated">
          {{ itm.customerName }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-1 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-md-5 d-flex justify-content-start">
        <span class="">Unique Identifier:</span>
      </div>
      <div class="col-6 col-md-7 d-flex justify-content-start font-weight-bold mx-md-0 px-md-0">
        <span class="itemCreated">
          {{ itm.customerUniqueIdentifier }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-2 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-5 col-md-4 d-flex justify-content-start">
        <span class="">Product:</span>
      </div>
      <div class="col-7 col-md-8 d-flex justify-content-start font-weight-bold mx-md-0 px-md-0">
        <span class="itemCreated">
          {{
          itm.loanProductCode === 100
          ? "SAVINGS"
          : itm.loanProductCode === 200
          ? "BODA BODA FUEL LOAN"
          : itm.loanProductCode === 300
          ? "TAXI FUEL LOAN"
          : "MICRO LOAN"
          }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-3 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-5 col-md-4 d-flex justify-content-start">
        <span class="">Town:</span>
      </div>
      <div class="col-7 col-md-8 d-flex justify-content-start font-weight-bold mx-md-0 px-md-0">
        <span class="itemCreated">
          {{ itm.townName }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-4 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-5 col-md-4 d-flex justify-content-start">
        <span class="">Station:</span>
      </div>
      <div class="col-7 col-md-8 d-flex justify-content-start font-weight-bold mx-md-0 px-md-0">
        <span class="itemCreated">
          {{ itm.stationName }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-5 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-md-5 d-flex justify-content-start">
        <span class="">Amount Borrowed:</span>
      </div>
      <div class="col-6 col-md-7 d-flex justify-content-start font-weight-bold mx-md-0 px-md-0">
        <span class="itemCreated">
          {{ itm.loanAmountTaken | number }}
        </span>
      </div>
    </div>
  </div>
  <div class="field col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-md-4 d-flex justify-content-start">
        <span class="">Interest Rate(%):</span>
      </div>
      <div class="col-6 col-md-8 d-flex justify-content-start font-weight-bold mx-md-0 px-md-0">
        <span class="itemCreated"> {{ itm.rateUsed }} %  year </span>
      </div>
    </div>
  </div>
  <div class="field-1 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-md-4 d-flex justify-content-start">
        <span class="">Revenue Lost:</span>
      </div>
      <div class="col-6 col-md-8 d-flex justify-content-start font-weight-bold mx-md-0 px-md-0">
        <span class="itemCreated">
          {{ itm.revenueLost | number }}
        </span>
      </div>
    </div>
  </div>
</div>
